<template>
  <v-footer app absolute padless>
    <v-col cols="12" class="justify-center py-2 align-center d-flex">
      <span class="align-self-center mr-2">Site Built With </span>
      <v-btn
        id="minimart-btn"
        color="grey lighten-2"
        tile
        outlined
        class="px-2 caslon--font"
        :href="`https://getminimart.com?ref=minimart&shop=${getShopTitle}`"
        depressed
        small
        >Minimart</v-btn
      >
    </v-col></v-footer
  >
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Footer',
  components: {},
  computed: mapGetters('shop', ['getShopTitle']),
  data() {
    return {}
  },
}
</script>

<style lang="scss">
#minimart-btn {
  .v-btn__content {
    color: rgba(black, 0.9) !important;
  }
}
</style>
